export const ROUTES = {
  dashboard: '/dashboard',
  projects: '/dashboard/projects',
  sources: '/dashboard/sources',
} as const;
